/* eslint-disable no-shadow */
/* eslint-disable no-promise-executor-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { GrLocation } from "react-icons/gr";
import { SlArrowRight } from "react-icons/sl";
import { RiSendPlaneLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
import Select from "react-select";
import { StoreContext } from "../context/StoreContext";

const CityModal = (props) => {
  const searchTimeoutRef = useRef(null);
  const cityAvailable = localStorage.getItem("selectedCity");
  const [selectedState, setSelectedState] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentLocation, setCurrentLocation] = useState(cityAvailable || "");
  const [isClicked, setIsClicked] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const {
    selectedOption,
    setSelectedOption,
    fetchCurrentLocation,
    setLoader,
    setSelectedStore,
    setCityLatLng,
    statesData,
    setPageNo,
  } = useContext(StoreContext);

  const handleCityModal = async () => {
    if (!selectedState) {
      await Swal.fire({
        icon: "warning",
        title: "No State Selected",
        text: "Please select State!",
        confirmButtonText: "OK",
      });
      return;
    }
    if (!selectedOption) {
      await Swal.fire({
        icon: "warning",
        title: "No Location Selected",
        text: "Please select a location!",
        confirmButtonText: "OK",
      });
      return;
    }

    localStorage.setItem("StateId", selectedState.id);
    localStorage.setItem("maxCordinates", selectedState?.maxCordinates?.String);
    localStorage.setItem("minCordinates", selectedState?.minCordinates?.String);

    setSelectedStore({ name: "All Stores", storeTypeID: "" });

    setPageNo(1);

    props?.setShowModal(false);
    setErrorMsg("");
    setLoader(true);
    setCityLatLng({
      lat: parseFloat(selectedOption.lat),
      lng: parseFloat(selectedOption.lon),
    });
    localStorage.setItem("selectedCity", selectedOption?.name);
    localStorage.setItem("selectedCityLat", selectedOption?.lat);
    localStorage.setItem("selectedCityLng", selectedOption?.lon);
    localStorage.setItem("modalShown", "true");

    if (selectedState?.id) {
      const stateKey = `recentLocations_${selectedState.id}`;
      let locations = [];
      const saved = Cookies.get(stateKey);
      if (saved) {
        try {
          locations = JSON.parse(saved);
        } catch {
          locations = [];
        }
      }
      const newEntry = {
        name: selectedOption?.name,
        lat: selectedOption?.lat,
        lon: selectedOption?.lon,
      };

      locations = [
        newEntry,
        ...locations.filter((loc) => loc.name !== newEntry.name),
      ];

      Cookies.set(stateKey, JSON.stringify(locations.slice(0, 3)), {
        expires: 30,
      });
    }
  };

  const searchAddresses = async (query) => {
    const baseUrl = process.env.REACT_APP_LOCATIONIQ_URL;
    const apiKey = process.env.REACT_APP_LOCATION_KEY;
    setErrorMsg("");
    setSelectedOption(null);

    if (!query || query.length < 3 || !apiKey) {
      if (selectedState?.id) {
        const stateKey = `recentLocations_${selectedState.id}`;
        const recent = JSON.parse(Cookies.get(stateKey) || "[]");
        setSuggestions(recent);
      } else {
        setSuggestions([]);
      }
      return;
    }

    try {
      const viewboxes = {};
      statesData.forEach((s) => {
        if (s.minCordinates && s.maxCordinates) {
          viewboxes[s.name.String] =
            `${s.minCordinates.String.split(",")[1]},${s.minCordinates.String.split(",")[0]},${s.maxCordinates.String.split(",")[1]},${s.maxCordinates.String.split(",")[0]}`;
        }
      });

      const viewbox = selectedState?.name
        ? viewboxes[selectedState.name.String]
        : "";
      const url = `${baseUrl}?key=${apiKey}&q=${encodeURIComponent(query)}&limit=10${
        viewbox ? `&viewbox=${viewbox}&bounded=1` : ""
      }`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();

        const filtered = data.filter(
          (item) =>
            item.address?.country_code === "in" &&
            (!selectedState?.name ||
              (item.address?.state &&
                item.address.state.toLowerCase() ===
                  selectedState.name.String.toLowerCase())),
        );

        const results = filtered.map((item) => ({
          id: item.place_id,
          name: item.display_name,
          lat: parseFloat(item.lat),
          lon: parseFloat(item.lon),
          address: item.address,
          stateName: selectedState?.name.String || item.address?.state,
          raw: item,
        }));
        setSuggestions(results);

        return;
      }

      setSuggestions([]);
    } catch (error) {
      console.warn("Search error:", error);
      setSuggestions([]);
    }
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setSearchText(value);
    setErrorMsg("");
    setSelectedOption(null);
    setCurrentLocation("");
    if (value === "") {
      const recent = JSON.parse(Cookies.get("recentLocations") || "[]");
      setSuggestions(recent);
      setSearchText("");
      return;
    }
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      searchAddresses(value);
    }, 500);
  };

  const handleSelectSuggestion = (suggestion) => {
    setSelectedOption(suggestion);
    setSearchText(suggestion.name);
    setIsClicked(false);
  };

  const handleUseCurrentLocation = async () => {
    const locationData = await fetchCurrentLocation();
    setPageNo(1);

    if (locationData?.city) {
      const displayName = `${locationData.city}, ${locationData.region}, ${locationData.zip}, ${locationData.country}`;
      const stateObj = statesData.find(
        (s) => s.name.String.toLowerCase() === locationData.state.toLowerCase(),
      );

      if (!stateObj) {
        setErrorMsg("Your current state is out of service.");
        setIsClicked(false);
        return;
      }

      const newLocation = {
        name: displayName,
        lat: locationData.latitude,
        lon: locationData.longitude,
        stateId: stateObj.id,
      };

      setSelectedState(stateObj);
      localStorage.setItem("StateId", stateObj.id);
      localStorage.setItem(
        "SelectedminCordinates",
        stateObj.minCordinates.String,
      );
      localStorage.setItem(
        "SelectedmaxCordinates",
        stateObj.maxCordinates.String,
      );
      setSearchText(displayName);
      setCurrentLocation(displayName);
      setIsClicked(true);
      setSelectedOption(newLocation);
      setErrorMsg("");
      setSelectedStore({ name: "All Stores", storeTypeID: "" });
      props?.setShowModal(false);
      setLoader(true);
      setCityLatLng({
        lat: parseFloat(newLocation.lat),
        lng: parseFloat(newLocation.lon),
      });
      localStorage.setItem("selectedCity", newLocation?.name);
      localStorage.setItem("selectedCityLat", newLocation?.lat);
      localStorage.setItem("selectedCityLng", newLocation?.lon);
      localStorage.setItem("modalShown", "true");
      const stateKey = `recentLocations_${stateObj.id}`;
      let locations = [];
      const saved = Cookies.get(stateKey);
      if (saved) {
        try {
          locations = JSON.parse(saved);
        } catch {
          locations = [];
        }
      }

      const newEntry = {
        name: newLocation.name,
        lat: newLocation.lat,
        lon: newLocation.lon,
      };

      locations = [
        newEntry,
        ...locations.filter((loc) => loc.name !== newEntry.name),
      ];
      Cookies.set(stateKey, JSON.stringify(locations.slice(0, 3)), {
        expires: 30,
      });

      setTimeout(() => setLoader(false), 2000);
    } else {
      setErrorMsg("Unable to fetch your location. Try searching manually.");
      setIsClicked(false);
    }
  };

  useEffect(() => {
    if (props?.showModal) {
      setSearchText("");
      setErrorMsg("");
      setSelectedOption(null);

      if (selectedState?.id) {
        const stateKey = `recentLocations_${selectedState.id}`;
        const cookieData = Cookies.get(stateKey);
        if (cookieData) {
          try {
            setSuggestions(JSON.parse(cookieData));
          } catch (e) {
            console.warn("Cookie parse error:", e);
            setSuggestions([]);
          }
        } else {
          setSuggestions([]);
        }
      } else {
        setSuggestions([]);
      }
    }
  }, [props?.showModal, selectedState?.id]);

  const handleStateChange = (e) => {
    const selectedId = parseInt(e.target.value, 10);
    const stateObj = statesData.find((s) => s.id === selectedId);

    if (stateObj) {
      setCurrentLocation("");
      setSelectedState(stateObj);
      const stateKey = `recentLocations_${stateObj.id}`;
      const saved = Cookies.get(stateKey);
      if (saved) {
        try {
          setSuggestions(JSON.parse(saved));
        } catch {
          setSuggestions([]);
        }
      } else {
        setSuggestions([]);
      }
    } else {
      setSelectedState(null);
      setSuggestions([]);
    }

    setSearchText("");
    setSelectedOption(null);
  };

  useEffect(() => {
    if (props?.showModal) {
      const stateId = localStorage.getItem("StateId");
      if (stateId) {
        const stateObj = statesData.find((s) => s.id === parseInt(stateId, 10));
        setCurrentLocation(cityAvailable);
        setSelectedState(stateObj || "");
      } else {
        setSelectedState("");
        setCurrentLocation("");
      }

      setSearchText("");
      setErrorMsg("");
      setSelectedOption(null);

      if (stateId) {
        const stateKey = `recentLocations_${stateId}`;
        const saved = Cookies.get(stateKey);
        setSuggestions(saved ? JSON.parse(saved) : []);
      } else {
        setSuggestions([]);
      }
    }
  }, [props?.showModal, statesData]);

  const options = statesData.map((state) => ({
    value: state?.id,
    label: state.name?.String,
  }));

  return (
    <CModal
      className="modal-wrapper ezybuy-select-city-alert"
      visible={props?.showModal}
      size="md"
      backdrop="static"
      keyboard={false}
      onClose={() => {
        setSelectedState("");
        if (cityAvailable) props.setShowModal(false);
      }}
    >
      <CModalHeader
        className="modal-header location-close-button"
        closeButton={!!cityAvailable}
      >
        <CModalTitle className="modal-title">Search Location</CModalTitle>
      </CModalHeader>

      <CModalBody className="modal-body global-button-city pb-0">
        <div className="state-input">
          {/* <select
            className="form-control mb-3 location-input"
            value={selectedState?.id || ""}
            onChange={handleStateChange}
          >
            <option value="" disabled className="state-options">
              Select State
            </option>
            {statesData.map((state) => (
              <option
                key={state?.id}
                value={state?.id}
                className="state-options"
              >
                {state.name?.String}
              </option>
            ))}
          </select> */}

          <Select
            value={
              options.find((opt) => opt.value === selectedState?.id) || null
            }
            onChange={(selectedOption) =>
              handleStateChange({ target: { value: selectedOption.value } })
            }
            options={options}
            placeholder="Select State"
            className="state-input mb-3"
            classNamePrefix="react-select"
          />
        </div>
        <div className="city-search-input-wrapper">
          <input
            type="text"
            className="form-control mb-3 location-input"
            placeholder="Enter your location"
            value={searchText || currentLocation}
            onChange={handleInputChange}
            disabled={!selectedState?.id}
          />
          {searchText && (
            <button
              className="city-searchtext-remove-btn"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setSearchText("");
                setCurrentLocation("");
                setSelectedOption(null);
                if (selectedState?.id) {
                  const stateKey = `recentLocations_${selectedState.id}`;
                  const saved = Cookies.get(stateKey);
                  if (saved) {
                    setSuggestions(JSON.parse(saved));
                  } else {
                    setSuggestions([]);
                  }
                } else {
                  setSuggestions([]);
                }
              }}
            >
              <RxCross2 size={16} />
            </button>
          )}
        </div>
        {suggestions.length > 0 && selectedState?.id && (
          <div
            className="border rounded p-2 mb-2 bg-white shadow-sm"
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              background: "#f9f9f9",
              border: "1px solid #e7e7e7 !important",
            }}
          >
            {suggestions.map((item, idx) => (
              <div
                key={idx}
                className="p-1 suggestion-item"
                style={{
                  cursor: "pointer",
                  padding: "6px 8px",
                }}
                title={item.name}
                onClick={() => handleSelectSuggestion(item)}
              >
                <div className="group-content-f1 d-f a-c j-start gap-1">
                  <GrLocation color="#009688" />
                  <div className="suggested-loactions-texts">{item.name}</div>
                </div>

                <SlArrowRight color="#009688" size={12} />
              </div>
            ))}
          </div>
        )}

        <CButton
          variant="outline"
          className={
            isClicked && searchText === currentLocation
              ? "w-100 border rounded p-2 mb-2 bg-white shadow-sm gap-1 curent-location-btn active"
              : "w-100 border rounded p-2 mb-2 bg-white shadow-sm gap-1 curent-location-btn"
          }
          onClick={handleUseCurrentLocation}
        >
          <RiSendPlaneLine color="#009688" size={18} />
          <span>
            Use My Current Location
            <SlArrowRight color="#009688" size={13} />
          </span>
        </CButton>

        <span className="text-danger d-block mt-2">{errorMsg}</span>
      </CModalBody>

      <CModalFooter className="modal-footer button-confirm-location">
        <CButton
          className="w-100 confirm-location-btn mb-0"
          onClick={handleCityModal}
        >
          Confirm Location
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default CityModal;
